/**
 * Click-to-load media embeds.
 *
 * A YouTube or Vimeo iframe pulls in a large amount of third-party
 * JavaScript before anyone has decided to watch anything. Three of them on
 * one page is a genuinely slow page. So the card renders a poster image and
 * a play control, and the iframe is only created when someone actually
 * clicks — at which point autoplay makes it feel like a normal player.
 *
 * Delegated from the document so any number of cards work with one listener,
 * including any added later by section rendering.
 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-embed-src]');
  if (!trigger) return;

  event.preventDefault();

  const src = trigger.dataset.embedSrc;
  if (!src) return;

  const frame = document.createElement('iframe');
  frame.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
  frame.title = trigger.dataset.embedTitle || 'Embedded media';
  frame.loading = 'lazy';
  frame.setAttribute(
    'allow',
    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
  );
  frame.setAttribute('allowfullscreen', '');
  frame.className = 'tdm-embed__frame';

  trigger.replaceWith(frame);
  // Move focus into the player so keyboard users aren't stranded where the
  // button used to be.
  frame.focus?.();
});
